import { Dimensions } from 'react-native';

const SCREEN_HEIGHT = Dimensions.get('window').height;
const SCREEN_WIDTH = Dimensions.get('window').width;

let coef = 1;
if (SCREEN_WIDTH < 360) {
	coef = 0.95;
}
if (SCREEN_WIDTH < 340) {
	coef = 0.85;
}

export default coef;
